export const playlist = {
  'Public playlist': 'Playlist',
  songs: 'canciones',
  song: 'canción',
  Name: 'Nombre',
  Filter: 'Filtrar',
  Add: 'Agregar',
  'Edit details': 'Editar detalles',
  'Make private': 'Hacer privada',
  'Make public': 'Hacer pública',
  'New playlist': 'Nueva playlist',
  'Date Added': 'Fecha en que se agregó',
  'Add to playlist': 'Agregar a una playlist',
  'Remove from this playlist': 'Eliminar de esta playlist',
  'Added to playlist': 'Agregado a la playlist',
  'Removed from playlist': 'Eliminado de la playlist',
  'Add to queue': 'Agregar a la cola',
  'Added to queue': 'Agregado a la cola',
  'Go to album': 'Ir al álbum',
  'Go to artist': 'Ir al artista',
  'Delete playlist': 'Eliminar playlist',
  'Liked Songs': 'Canciones guardadas',
  Title: 'Título',
  Album: 'Álbum',
  Artist: 'Artista',
  Disk: 'Disco',
  saves: 'seguidores',
  Save: 'Guardar',
  'Choose photo': 'Elegir foto',
  'Remove from Your Library': 'Eliminar de Tu biblioteca',
  'Removed from Your Library': 'Eliminado de Tu biblioteca',
  'Add to Your Library': 'Guardar en Tu biblioteca',
  'Saved to Your Library': 'Guardado en Tu biblioteca',
  'Add to Liked Songs': 'Agregar a Tus me gusta',
  'Remove from Liked Songs': 'Eliminar de Canciones Me Gusta',
  'Private Playlist': 'Playlist Privada',
  Follow: 'Seguir',
  Unfollow: 'Dejar de seguir',
  'Artist unfollowed': 'Dejaste de seguir al artista',
  'Artist followed': 'Empezaste a seguir al artista',
};
